import type { ReleaseT } from '../types'

const release: ReleaseT = {
  usefulContent: {
    description:
      'React Native 0.59 includes React Hooks, performance gains on Android and lots of cool stuff.',
    links: [
      {
        title:
          'Official blog post about the major changes on React Native 0.59',
        url: 'https://facebook.github.io/react-native/blog/2019/03/12/releasing-react-native-059',
      },
      {
        title: '[External] Tutorial on upgrading to React Native 0.59',
        url: 'https://reactnative.thenativebits.com/courses/upgrading-react-native/upgrade-to-react-native-0.59/',
      },
    ],
  },
}

export default release
